import React, { useEffect, useState } from "react";
import "./clientrows.css";
import GenerateNumber from "./GenerateNumber";
import AnimatedText from "./AnimatedText";
import  befisc_logo_mobile from "../images/befisc_logo_mobile.svg";

const leftCarouselItems = [
  {
    imgSrc: "/images/indiamart-white.png",
    text: "Indiamart",
    className: "left-carosul-items left-item1",
  },
  {
    imgSrc: "/images/bajaj-finserv-white.png",
    text: "Bajaj Finserv",
    className: "left-carosul-items left-item2",
  },
  {
    imgSrc: "/images/muthoot-capital-white.png",
    text: "Muthoot Capital",
    className: "left-carosul-items left-item3",
  },
  {
    imgSrc: "/images/navi-white.png",
    text: "Navi",
    className: "left-carosul-items left-item4",
  },
  {
    imgSrc: "/images/snapmint-white.png",
    text: "Snapmint",
    className: "left-carosul-items left-item5",
  },
  {
    imgSrc: "/images/cashrich-white.png",
    text: "Cashrich",
    className: "left-carosul-items left-item6",
  },
  {
    imgSrc: "/images/freo-white.png",
    text: "Freo",
    className: "left-carosul-items left-item7",
  },
  {
    imgSrc: "/images/bharatx-white.png",
    text: "BharatX",
    className: "left-carosul-items left-item8",
  },
  {
    imgSrc: "/images/credflow-white.png",
    text: "CredFlow",
    className: "left-carosul-items left-item9",
  },
  {
    imgSrc: "/images/niro-white.png",
    text: "Niro",
    className: "left-carosul-items left-item10",
  },
  {
    imgSrc: "/images/epaylater-white.png",
    text: "EPay Later",
    className: "left-carosul-items left-item11",
  },
  {
    imgSrc: "/images/godigit-white.png",
    text: "Go Digit",
    className: "left-carosul-items left-item12",
  },
  {
    imgSrc: "/images/indiap2p-white.png",
    text: "India P2P",
    className: "left-carosul-items left-item13",
  },
  {
    imgSrc: "/images/sabpaisa-white.png",
    text: "SabPaisa",
    className: "left-carosul-items left-item14",
  },
  {
    imgSrc: "/images/olvy-white.png",
    text: "Olyv",
    className: "left-carosul-items left-item15",
  },
  {
    imgSrc: "/images/varthana-white.png",
    text: "Varthana",
    className: "left-carosul-items left-item16",
  },
  {
    imgSrc: "/images/payinstacard-white.png",
    text: "Payinstacard",
    className: "left-carosul-items left-item17",
  },
];

const rightCarouselItems = [
  {
    imgSrc: "/images/indiamart.png",
    text: "Indiamart",
    className: "right-carosul-items right-item5",
  },
  {
    imgSrc: "/images/bajaj-finserv.png",
    text: "Bajaj Finserv",
    className: "right-carosul-items right-item6",
  },
  {
    imgSrc: "/images/muthoot-capital.png",
    text: "Muthoot Capital",
    className: "right-carosul-items right-item7",
  },
  {
    imgSrc: "/images/navi.png",
    text: "Navi",
    className: "right-carosul-items right-item8",
  },
  {
    imgSrc: "/images/snapmint.png",
    text: "Snapmint",
    className: "right-carosul-items right-item9",
  },
  {
    imgSrc: "/images/cashrich.png",
    text: "Cashrich",
    className: "right-carosul-items right-item10",
  },
  {
    imgSrc: "/images/freo.png",
    text: "Freo",
    className: "right-carosul-items right-item11",
  },
  {
    imgSrc: "/images/bharatx.png",
    text: "BharatX",
    className: "right-carosul-items right-item12",
  },
  {
    imgSrc: "/images/credflow.png",
    text: "CredFlow",
    className: "right-carosul-items right-item13",
  },
  {
    imgSrc: "/images/niro.png",
    text: "Niro",
    className: "right-carosul-items right-item14",
  },
  {
    imgSrc: "/images/epaylater.png",
    text: "EPay Later",
    className: "right-carosul-items right-item15",
  },
  {
    imgSrc: "/images/godigit.png",
    text: "Go Digit",
    className: "right-carosul-items right-item16",
  },

  {
    imgSrc: "/images/indiap2p.png",
    text: "India P2P",
    className: "right-carosul-items right-item17",
  },
  {
    imgSrc: "/images/sabpaisa.png",
    text: "SabPaisa",
    className: "right-carosul-items right-item1",
  },
  {
    imgSrc: "/images/olvy.png",
    text: "Olyv",
    className: "right-carosul-items right-item2",
  },
  {
    imgSrc: "/images/varthana.png",
    text: "Varthana",
    className: "right-carosul-items right-item3",
  },
  {
    imgSrc: "/images/payinstacard.png",
    text: "Payinstacard",
    className: "right-carosul-items right-item4",
  },
];

const texts = [
  "Product Uses",
  "Document Authenticated",
  "Email Validated",
  "Tampering Checked",
  "Digital Signature Verified",
];


function ClientRows() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 2000); // change text every 2 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="rows-wrapper">
      <div className="rows-text-section">
        <h1 className="row-text-heading">
          Trusted by World’s <br />
          <span>Most Dependable </span>
          Businesses
        </h1>
      </div>
      <div className="client-carosul-animation">
        <div className="carosul-left-wrapper">
          <CarouselSection items={leftCarouselItems} />
        </div>
        <img
          src="/images/Shield Landing Page.svg"
          alt=""
          width="20rem"
          loading="lazy"
          decoding="async"
          className="mobile-hide"
        />
        <div className="generatecomponent mobile-hide">
          <GenerateNumber />
        </div>
        <AnimatedText />
        <div className="carosul-right-wrapper mobile-hide">
          <CarouselSection items={rightCarouselItems} />
        </div>
      </div>
      <div className="mobile-view-section">
        <img src={befisc_logo_mobile} alt="mobile-logo" />

        <div className="randon-number">
          999,737,219,894,235
        </div>


        <div key={index} className="animated-text">
          {texts[index]}
        </div>

      </div>
    </div>
  );
}

export default React.memo(ClientRows);

const ImageAndText = React.memo(({ imgSrc, text, classname }) => {
  return (
    <div className={`image-group ${classname}`}>
      <img src={imgSrc} alt="" loading="lazy" decoding="async" />
      <figcaption>{text}</figcaption>
    </div>
  );
});
const CarouselSection = React.memo(({ items }) => (
  <div className="carousel-wrapper">
    {items.map((item, index) => (
      <ImageAndText
        key={index}
        imgSrc={item.imgSrc}
        text={item.text}
        classname={item.className}
      />
    ))}
  </div>
));
